export const LT_MONTHS = [
  'Sausis',
  'Vasaris',
  'Kovas',
  'Balandis',
  'Gegužė',
  'Birželis',
  'Liepa',
  'Rugpjūtis',
  'Rugsėjis',
  'Spalis',
  'Lapkritis',
  'Gruodis',
]

export const LT_MONTHS_GENITIVE = [
  'Sausio',
  'Vasario',
  'Kovo',
  'Balandžio',
  'Gegužės',
  'Birželio',
  'Liepos',
  'Rugpjūčio',
  'Rugsėjo',
  'Spalio',
  'Lapkričio',
  'Gruodžio',
]

export const LT_WEEKDAY_SHORT = ['Pr', 'An', 'Tr', 'Kt', 'Pn', 'Št', 'Sk']

export const LT_WEEKDAY_FULL = [
  'Pirmadienis',
  'Antradienis',
  'Trečiadienis',
  'Ketvirtadienis',
  'Penktadienis',
  'Šeštadienis',
  'Sekmadienis',
]

export interface MonthGrid {
  year: number
  month: number
  label: string
  leadingBlanks: number
  days: {
    day: number
    active: boolean
  }[]
}

/** Monday-first index (0 = Monday … 6 = Sunday) */
function mondayIndex(date: Date): number {
  return (date.getDay() + 6) % 7
}

function parse(iso: string): Date {
  const [y, m, d] = iso.split('-').map(Number)
  return new Date(y, m - 1, d)
}

export function formatRange(startIso: string, endIso: string): string {
  const start = parse(startIso)
  const end = parse(endIso)
  const startLabel = `${LT_MONTHS_GENITIVE[start.getMonth()]} ${start.getDate()}`
  const endLabel = `${LT_MONTHS_GENITIVE[end.getMonth()]} ${end.getDate()}`
  return `${startLabel} – ${endLabel}, ${end.getFullYear()}`
}

/**
 * Builds one grid per month spanned by the course, marking the days that
 * fall on the course weekdays and inside the start/end range.
 * `weekdays` uses Monday-first indexes (0 = Monday).
 */
export function buildCourseMonths(
  startIso: string,
  endIso: string,
  weekdays: number[],
): MonthGrid[] {
  const start = parse(startIso)
  const end = parse(endIso)
  const grids: MonthGrid[] = []
  const cursor = new Date(start.getFullYear(), start.getMonth(), 1)

  while (
    cursor.getFullYear() < end.getFullYear() ||
    (cursor.getFullYear() === end.getFullYear() &&
      cursor.getMonth() <= end.getMonth())
  ) {
    const year = cursor.getFullYear()
    const month = cursor.getMonth()
    const daysInMonth = new Date(year, month + 1, 0).getDate()
    const days = Array.from({ length: daysInMonth }, (_, i) => {
      const date = new Date(year, month, i + 1)
      const inRange = date >= start && date <= end
      return {
        day: i + 1,
        active: inRange && weekdays.includes(mondayIndex(date)),
      }
    })

    grids.push({
      year,
      month,
      label: `${LT_MONTHS[month]} ${year}`,
      leadingBlanks: mondayIndex(new Date(year, month, 1)),
      days,
    })

    cursor.setMonth(cursor.getMonth() + 1)
  }

  return grids
}

export function countSessions(
  startIso: string,
  endIso: string,
  weekdays: number[],
): number {
  return buildCourseMonths(startIso, endIso, weekdays).reduce(
    (total, grid) => total + grid.days.filter((d) => d.active).length,
    0,
  )
}
